import  React from 'react';

export const GeneralInput = ({id, label, onInputChange, value, maxLength , title = null}) => {
  let labelItem = (
      <label className="input-label">
        {label}
      </label>
    );

  let inputItem = (
      <GeneralInputField
        className="text-field"
        id={id}
        maxLength={maxLength}
        onInputChange={ onInputChange }
        value={ value }
      />
  );

  return(
    <div className="select-dropdown">
    { title && <div className="head">{title}</div> }
    <div id={id} className="general-text-field input-item">
      {inputItem}
      {labelItem}
    </div>
    </div>
  );
};

const GeneralInputField = ({id, maxLength, onInputChange, value}) => {

  return(
      <input
        className="input"
        type="text"
        maxLength={maxLength ? maxLength : '128'}
        onInput={ ({target} ) => onInputChange(target.value) }
        onChange={() => {}}
        value={ value }
        id={id + "Input"}
      />
  );

};
